import { API_CONFIG } from '@/constants/config';
import apiClient from '@/services/apiClient';
import { toE164 } from '@/utils/phone-validation';

function buildAuthQuery(auth) {
    if (typeof auth === 'string' && auth) {
        return `encryptedSSOData=${encodeURIComponent(auth)}`;
    }
    if (auth && typeof auth === 'object' && auth.userId && auth.locationId) {
        return `userId=${encodeURIComponent(auth.userId)}&locationId=${encodeURIComponent(auth.locationId)}`;
    }
    return '';
}

function buildAuthBodyFields(auth) {
    if (typeof auth === 'string' && auth) {
        return { encryptedSSOData: auth };
    }
    if (auth && typeof auth === 'object' && auth.userId && auth.locationId) {
        return { userId: auth.userId, locationId: auth.locationId };
    }
    return {};
}

async function searchContacts(
    auth,
    operation,
    term = '',
    limit = 100,
    showToast = true,
    selectedBnumCountry = null
) {
    // Convert number to E.164 format if country is provided
    let searchTerm = term;
    if (selectedBnumCountry && term) {
        const country = selectedBnumCountry.toLowerCase();
        searchTerm = toE164(term, country);
    }

    const authQuery = buildAuthQuery(auth);
    const prefix = `${API_CONFIG.ENDPOINTS.SEARCH_CONTACTS}?`;
    const qs = `${authQuery}${authQuery ? '&' : ''}operation=${operation}&term=${encodeURIComponent(searchTerm)}&limit=${limit}`;
    return apiClient(`${prefix}${qs}`, {}, showToast);
}

async function getBnums(auth, showToast = true) {
    const authQuery = buildAuthQuery(auth);
    const prefix = `${API_CONFIG.ENDPOINTS.WEBCALL_BNUMS}`;
    const url = authQuery ? `${prefix}?${authQuery}` : prefix;
    console.log('url', url);
    return apiClient(url, {}, showToast);
}

async function selectBnum(bnum, auth, showToast = true) {
    const authFields = buildAuthBodyFields(auth);
    return apiClient(
        API_CONFIG.ENDPOINTS.WEBCALL_BNUMS,
        {
            method: 'POST',
            body: JSON.stringify({
                bnum,
                ...authFields,
            }),
        },
        showToast
    );
}

export { searchContacts, getBnums, selectBnum };
